import { assertNever } from '@kofno/piper';
import { Maybe } from 'maybeasy';
import { action, makeObservable, observable } from 'mobx';
import { TProps } from '../../../Translations';
import { hidden, showing, State } from './Types';

/**
 * A single toast slot. Showing a toast replaces whatever is on screen, and
 * every toast carries its own id so an older toast's timer can never close
 * a newer one.
 */
class ToastStore {
  @observable
  state: State = hidden();

  private nextId: number = 1;

  constructor() {
    makeObservable(this);
  }

  @action
  show = (message: TProps, undo: Maybe<() => void>) => {
    this.state = showing({ id: this.nextId, message, undo });
    this.nextId = this.nextId + 1;
  };

  @action
  expire = (id: number) => {
    switch (this.state.kind) {
      case 'hidden':
        break;
      case 'showing':
        this.state = this.state.toast.id === id ? hidden() : this.state;
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  undo = () => {
    switch (this.state.kind) {
      case 'hidden':
        break;
      case 'showing':
        this.state.toast.undo.do((undo) => undo());
        this.state = hidden();
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  dismiss = () => {
    this.state = hidden();
  };
}

export default ToastStore;
